import {User} from '@ui/types/user';

// stored as a single json row in the settings table ("acknowledgment" key)
// and exposed to the frontend through bootstrap data like any other setting
export interface AcknowledgmentConfig {
  enabled?: boolean;
  title?: string;
  body?: string;
  // bumping this re-prompts every customer; users store the version they
  // accepted in acknowledged_version
  version?: number | string;
}

// One rule, used by both the router takeover (common-provider) and the page
// itself. It MUST mirror EnsureAcknowledgmentAccepted on the server exactly:
// if the two ever disagree, a customer either sees the app while every API
// call fails, or is trapped on the acknowledgment page the server thinks
// they have already left.
export function requiresAcknowledgment(
  user: User | null,
  config: AcknowledgmentConfig | undefined,
  hasPermission: (permission: string) => boolean,
): boolean {
  if (!user || !config?.enabled || !config.body?.trim()) {
    return false;
  }

  // only the Main User (organization owner) acknowledges; staff and dealers
  // manage the platform rather than subscribe to it, and sub users are
  // covered by their Main User's acceptance
  if (!user.organization || user.organization.owner_id !== user.id) {
    return false;
  }
  if (hasPermission('admin.access')) {
    return false;
  }

  const version = Number(config.version ?? 1);
  return !(
    user.acknowledged_at && Number(user.acknowledged_version) === version
  );
}
